/** Veda Labs BoringVault Accountant `getRate()` — assets-per-share in
 *  the base asset's decimals (the BTC vaults are BTC-denominated at 8
 *  decimals). The vault share token itself exposes no ERC-4626 surface,
 *  so the rate is read from its Accountant. */
export const VedaAccountantGetRateAbi = [
  {
    name: 'getRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
